import { MARKETING_SECTION_HEADING_HIGHLIGHT_INFO_MESSAGE } from '@modules/whitelabel-cover-page/marketing-page-section/marketing-page-section.constants';

export const VIP_OFFERS_BANNER_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'vip-offers-banner-layout',
  LAYOUT_LABEL: 'VIP Deals Banner Layout',
  LAYOUT_IMAGE_PATH: 'https://cdn-www.topfans.com/TopFans/1786017372136.png',
  LAYOUT_DESCRIPTION:
    'Full-width banner with VIP deals list overlay and view buttons',
  DEFAULT_ALT_IMAGE: 'Banner background',
  DEFAULT_OFFER_ALT: 'VIP deal',
  DEFAULT_VIEW_OFFER_CTA: 'View Deal',
  END_DATE_FORMAT: 'mediumDate',
  VIP_OFFER_ROUTE_PREFIX: '/dashboard/vip-offer',
  HEADING_POSITION_LEFT: 'left',
  HEADING_POSITION_CENTER: 'center',
  HEADING_POSITION_RIGHT: 'right',
  INFO_HEADING_HIGHLIGHT: MARKETING_SECTION_HEADING_HIGHLIGHT_INFO_MESSAGE,
  labels: {
    TITLE: 'Title',
    SECTION_HEADING: 'Heading',
    SUBHEADING: 'Subheading',
    BACKGROUND_IMAGE: 'Background Image',
    OFFER_CTA_TEXT: 'Deal Button Label',
    HEADING_POSITION: 'Show Heading on',
    HEADING_POSITION_LEFT: 'Left',
    HEADING_POSITION_CENTER: 'Center',
    HEADING_POSITION_RIGHT: 'Right',
    VIP_OFFERS: 'VIP Deals',
    END_DATE: 'Ends'
  },
  placeholders: {
    TITLE: 'Enter title',
    SECTION_HEADING: 'Enter heading',
    SUBHEADING: 'Enter subheading',
    OFFER_CTA_TEXT: 'e.g. View Deal'
  },
  DATA_KEYS: {
    SECTION_TITLE: 'section_title',
    SECTION_HEADING: 'section_heading',
    SUBHEADING: 'subheading',
    BACKGROUND_IMAGE: 'background_image',
    HEADING_POSITION: 'heading_position',
    HEADING_FONT_SIZE: 'heading_font_size',
    OFFER_CTA_TEXT: 'offer_cta_text',
    VIP_OFFERS: 'vip_offers'
  }
} as const;
